import { convertToLocalTime } from "date-fns-timezone";
import { startOfDay, addHours } from "date-fns";
import { getTimezoneOffset } from "date-fns-tz";
export var getTestDate = function (date, timeZone, accountOffset) {
    if (timeZone === void 0) { timeZone = "America/Los_Angeles"; }
    if (accountOffset === void 0) { accountOffset = -7; }
    var userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var userOffset = getTimezoneOffset(userTz) / 3600000;
    var offsetDiff = Number(userOffset) - accountOffset;
    return addHours(startOfDay(convertToLocalTime(new Date(date), {
        timeZone: timeZone,
    })), offsetDiff);
};
export default {
    account: {
        id: 1,
        name: "Account",
    },
    units: {
        admixRatioUnit: "",
        loadSizeUnit: "",
        slumpUnit: "",
        speedUnit: "",
        temperatureUnit: "",
        waterRatioUnit: "",
        waterVolumeUnit: "",
    },
    timeZone: "America/Los_Angeles",
    defaultDate: new Date(),
};
//# sourceMappingURL=testAccount.js.map